import React, { useEffect } from "react";
import { Layout } from "@components/layout/Layout";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";


export const Risk_Disclosure = () => {
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight / 3) {
        document.body.classList.add("show-scroll-btn");
      } else {
        document.body.classList.remove("show-scroll-btn");
      }
    };
    const handleClick = () => {
      document.body.classList.toggle("hidden");
      document.documentElement.classList.toggle("hidden");
    };

    const checkMenu = document.getElementById("check-menu");
    if (checkMenu) {
      checkMenu.addEventListener("click", handleClick);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (checkMenu) {
        checkMenu.removeEventListener("click", handleClick);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    document.body.classList.add("main-page");
    return () => {
      document.body.classList?.remove("main-page");
    };
  }, []);

  return (
    <Layout>
      <div className="basic-main">
        <div className="container">
          <h1>Risk Disclosure</h1>
          <div className="section">

  <p>
    This Risk Disclosure outlines the potential risks associated with using the Cronika platform and conducting transactions involving digital or financial assets. All users must read and understand this disclosure before registering an account or engaging in any trading activity on the Cronika platform.
  </p>
  <h3>1. General Risk Acknowledgment</h3>

    <p>You are financially capable of bearing the risks associated with high-volatility markets.</p>
    <p>You fully understand the speculative nature of trading and accept the possibility of incurring full or partial losses.</p>
    <p>You make your own trading decisions based on independent judgment or external advice, not on any recommendation from Cronika.</p>
    <p>The value of products offered on Cronika is derived from underlying assets such as currencies, indices, stocks, or commodities. The following risks may apply:
    
        <p><strong>Volatility:</strong> Prices can fluctuate sharply and unpredictably, affecting your trades.</p>
        <p><strong>Market Gaps:</strong> Sudden price shifts can occur during or after market hours, impacting trade outcomes.</p>
        <p><strong>Liquidity:</strong> Market conditions or external events may reduce the ability to buy/sell assets efficiently.</p>
      
    </p>
  

  <h3>2. Technological and Infrastructure Risks</h3>


    <p>Interruptions in internet connectivity, power outages, or equipment failure.</p>
    <p>Malfunctioning of personal hardware or software.</p>
    <p>Latency or failure in communication between your device and Cronika’s servers.</p>
    <p>Inability to access or use the platform due to third-party service disruptions.</p>
  

  <h3>3. Market Conditions and Execution Risks</h3>

    <p>Orders may be delayed, rejected, or processed at unexpected prices due to rapid market changes.</p>
    <p>Under abnormal market conditions, execution times may increase, and some requests may be denied.</p>
    <p>The only accurate reference for asset prices is Cronika’s server. Local display on the user terminal may not reflect actual values.</p>
  

  <h3>4. Operational and Communication Risks</h3>

    <p>Closing your browser or losing internet connection does not cancel orders already received for processing.</p>
    <p>Orders may be duplicated if submitted repeatedly before confirmation is received.</p>
    <p>Losses may occur due to miscommunication, delayed notifications, or third-party interception.</p>
    <p>Emails or messages sent over unsecured channels may be subject to unauthorized access.</p>
  

  <h3>5. Confidentiality and Third-Party Access</h3>

    <p>You are solely responsible for safeguarding your account credentials and access to your Cronika account.</p>
    <p>Cronika is not liable for any unauthorized access resulting from your failure to maintain confidentiality.</p>
  

  <h3>6. Force Majeure</h3>

    <p>Natural disasters, wars, terrorism, civil unrest, regulatory changes.</p>
    <p>Infrastructure failures, cyberattacks, or significant disruptions in market operations.</p>
  

  <h3>7. Legal and Tax Compliance</h3>

    <p>You are responsible for complying with local laws regarding trading activities.</p>
    <p>You are solely responsible for any applicable taxes or charges related to your trades.</p>
  

  <h3>8. No Investment Advice</h3>

    <p>Cronika does not provide investment advice or guarantee profitability.</p>
    <p>Any information provided (including market commentary, news, or trading signals) is for informational purposes only and should not be considered a recommendation.</p>
  

  <h3>9. Final Statement</h3>
  <p>
    This disclosure is intended to assist users in evaluating the risks associated with trading via Cronika. It does not discourage participation but emphasizes the importance of informed decision-making. Users are encouraged to assess their personal financial situation, experience, and risk tolerance before trading.
  </p>

          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Risk_Disclosure;
